/* ==========================================================================
   SearcherFli > Client > Product > Openjaw
   ========================================================================== */

/* Modules */
const Radio = require('@bluekiri/alexandria-contrib-components/components/radio-button-rxjs/client/js');

/* eslint-disable */
const RadioActions = require('@bluekiri/alexandria-contrib-components/components/radio-button-rxjs/client/js/store/actions');
/* eslint-enable */

const { OPENJAW } = require('../constants');

const configuration = require('../../config');

/* Init */
function initOpenjaw(instance) {
    const panel = instance;

    /* Selector */
    const { selector } = instance;

    /* Reference */
    panel.openjaw = Radio(
        `${selector} [data-component='RadioButtonRxjs'][data-type='${configuration().type.openjaw}']`
    );

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        changeOpenjaws: instance.openjaw.store.subscribe((_, action) => {
            if (action.type !== RadioActions.types.TOGGLE) return;

            /* Dispatch */
            instance.actions.changeProduct(OPENJAW);
        })
    };

    /* Start */
    const { checked } = instance.openjaw.store.select('radio');

    if (!checked) {
        return;
    }

    /* Sync */
    instance.actions.setSearcher({ product: OPENJAW });
}

/* Destroy */
function destroyOpenjaw(instance) {
    const panel = instance;

    /* Reference */
    instance.openjaw.actions.destroy();
    delete panel.openjaw;

    /* Reactions */
    instance.reactions.changeOpenjaws.unsubscribe();
    delete panel.reactions.changeOpenjaws;
}

/* Exports */
module.exports = {
    initOpenjaw,
    destroyOpenjaw
};
